import React from 'react';
import {Redirect} from 'react-router-dom';
import {AuthState, useUserContext} from 'Contexts/UserContext/UserContext';
import PricingCard from './PricingCard';
import {GradientBorderButton} from 'Components/GradientBorderButton';
import {logEvent} from '@pmf/analytics';
import {getCheckoutUrl} from 'Common/api';

export const CALEB_CALENDLY_LINK = 'https://calendly.com/calebouellette/15min';
interface Props {}

export const Upgrade = (props: Props) => {
    const {userId, deviceId, sessionId, status, user} = useUserContext();

    if (AuthState.SIGNED_IN_PAID === status) {
        return <Redirect to="/" />;
    }

    return (
        <div className="mb-16 mt-32 flex w-full flex-col items-center justify-center gap-8">
            <PricingCard
                price={10}
                highlighted
                name="Pro"
                mainPerk="100 Credits / Month"
                perks={['Tailwind config file support', 'Global default CSS', 'Commercial Use']}
            >
                <GradientBorderButton
                    onClick={() => {
                        logEvent('Checkout Start', userId, {data: {sessionId, deviceId}, user});
                        window.open(getCheckoutUrl(userId));
                    }}
                >
                    Upgrade Now
                </GradientBorderButton>
            </PricingCard>
        </div>
    );
};
